// @ts-nocheck
import { useSelector } from 'react-redux';
import { selectPendingActions } from '../state/pending';
import useOnChange from './useOnChange';

function useOnPendingActionFinish(actions, callback) {
  const pendingActions = useSelector(selectPendingActions);

  useOnChange(pendingActions, prevPendingActions => {
    const hasActionFinished = actions.some(
      action => prevPendingActions.includes(action) && !pendingActions.includes(action)
    );
    if (hasActionFinished) {
      callback();
    }
  });
}

export default useOnPendingActionFinish;
